import BusSchool from "vue-material-design-icons/BusSchool.vue";
import Receipt from "vue-material-design-icons/Receipt.vue";
import CurrencyUsd from "vue-material-design-icons/CurrencyUsd.vue";
import AccountCircle from "vue-material-design-icons/AccountCircle.vue";
import Menu from "vue-material-design-icons/Menu.vue";
import Backburger from "vue-material-design-icons/Backburger.vue";
import CashUsd from "vue-material-design-icons/CashUsd.vue";

export default {
  components: {
    "bus-school-icon": BusSchool,
    "receipt-icon": Receipt,
    "money-sign-icon": CurrencyUsd,
    "account-icon": AccountCircle,
    "expand-sidebar-icon": Menu,
    "hide-sidebar-icon": Backburger,
    "money-receipt-icon": CashUsd
  },
  data() {
    return {
      expand: false,
      width: "6%",
      imageWidth: "50%",
      unidades: null,
      recibos: null,
      cobranza: null,
      recibosCobranza: null,
      socios: null,
      mySidebar: null,
      isSmall: false,
      isExpand: false,
      hamBtn: {
        visibility: "hidden"
      }
    };
  },
  methods: {
    show() {
      this.expand = true;
      this.width = "13rem";
    },
    hide() {
      if (this.isSmall) {
        this.mySidebar = {
          visibility: "hidden"
        };
      } else {
        this.expand = false;
        this.width = "6%";
      }
    },
    showMiniSidebar() {
      this.isSmall = true;
      this.expand = true;
      this.width = "13rem";
      this.mySidebar = {
        visibility: "visible"
      };
    }
  },
  created() {
    let ruta = this.$route.fullPath;
    switch (ruta) {
      case "/unidades":
        this.unidades = {
          backgroundColor: "#1976d2",
          color: "#fff",
          border: "solid 1px #1976d2"
        };
        break;
      case "/recibos":
        this.recibos = {
          backgroundColor: "#1976d2",
          color: "#fff",
          border: "solid 1px #1976d2"
        };
        break;
      case "/cobranza":
        this.cobranza = {
          backgroundColor: "#1976d2",
          color: "#fff",
          border: "solid 1px #1976d2"
        };
        break;
      case "/socio":
        this.socios = {
          backgroundColor: "#1976d2",
          color: "#fff",
          border: "solid 1px #1976d2"
        };
        break;
      case "/recibos-cobranza":
        this.recibosCobranza = {
          backgroundColor: "#1976d2",
          color: "#fff",
          border: "solid 1px #1976d2"
        };
    }
  }
};
